module.exports = __webpack_public_path__ + "img/join-profit-man.5afc81e9.png";